import type { TextProps } from 'react-native'
import { cn } from '~/lib/utils.ts'
import { Text } from '../ui/text'

export const Body = ({ children, className, ...props }: TextProps) => {
  return (
    <Text className={cn('text-pretty font-light text-base leading-normal', className)} {...props}>
      {children}
    </Text>
  )
}

export const Label = ({ children, className, ...props }: TextProps) => {
  return (
    <Text className={cn('font-light text-lg/normal', className)} {...props}>
      {children}
    </Text>
  )
}

export const DisplayValue = ({ children, className, ...props }: TextProps) => {
  return (
    <Text className={cn('font-semibold text-lg/normal', className)} {...props}>
      {children}
    </Text>
  )
}

export const Detail = ({ children, className, ...props }: TextProps) => {
  return (
    <Text className={cn('font-light text-sm/loose', className)} {...props}>
      {children}
    </Text>
  )
}
